import { Chip } from '@dxb-web-ui-framework/design-system';
import React, { FC } from 'react';
import { TFunction } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export interface PayrollRecordStatusChipProps {
  recordStatusDescription: 'OK' | string;
}

export const getPayrollRecordStatus: (
  recordStatusDescription: 'OK' | string,
  t: TFunction,
) => {
  value: string;
  color: 'success' | 'error';
} = (recordStatusDescription, t) => {
  switch (recordStatusDescription) {
    case 'OK':
      return { value: t('payrollPage.PayrollConfirmTable.PayrollRecordStatusChip.Success'), color: 'success' };
    default:
      return {
        value: t('payrollPage.PayrollConfirmTable.PayrollRecordStatusChip.Error'),
        color: 'error',
      };
  }
};
const PayrollRecordStatusChip: FC<PayrollRecordStatusChipProps> = ({ recordStatusDescription }) => {
  const { t } = useTranslation();

  return (
    <Chip
      label={getPayrollRecordStatus(recordStatusDescription, t).value}
      bgColor={getPayrollRecordStatus(recordStatusDescription, t).color}
    />
  );
};

export { PayrollRecordStatusChip };
